"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const URLs_1 = require("../utility/URLs");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const Paginator_1 = __importDefault(require("../../commonFiles/Paginator"));
function CategoryShow(props) {
    let { id } = (0, react_router_1.useParams)();
    const [category, setcategory] = react_1.default.useState();
    const [categoriesPag, setcategoriesPag] = react_1.default.useState();
    function setup() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchCategory(id); }), setcategory, 'CategoryShow', true);
        });
    }
    react_1.default.useEffect(() => {
        setup();
    }, []);
    function fetchArticles(params = null) {
        return URLs_1.Api.fetchArticles(Object.assign(Object.assign({}, params), { category_id: id, orderById: true }));
    }
    return (react_1.default.createElement("div", { className: "bg-white p-2 rounded" },
        react_1.default.createElement("div", { className: "d-flex justify-content-around p-2" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("strong", null, "\u0631\u0642\u0645 \u0627\u0644\u062A\u0635\u0646\u064A\u0641"),
                " ", category === null || category === void 0 ? void 0 :
                category.id),
            react_1.default.createElement("div", null,
                react_1.default.createElement("strong", null, "\u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u062A\u0635\u0646\u064A\u0641"),
                " ", category === null || category === void 0 ? void 0 :
                category.name),
            react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.categoryEdit(id) }, "\u062A\u0639\u062F\u064A\u0644")),
        react_1.default.createElement(Paginator_1.default, { log: 'fetch category articles', apiCall: fetchArticles, useState: [categoriesPag, setcategoriesPag] })));
}
exports.default = CategoryShow;
